import { graphql } from "msw";
import { mockCart, mockUserCoupon } from "./mockCart";
import { UserCouponQuery } from "@cart-app/generated/graphql";

const { id, orderSummary } = mockCart;

export const handler = graphql.query<UserCouponQuery>(
  "UserCoupon",
  (_request, response, context) => {
    return response(
      context.data({
        cart: {
          __typename: "Cart" as const,
          id,
          userCoupon: mockUserCoupon,
          orderSummary,
        },
      })
    );
  }
);
